export { default } from './CompaniesTicker';
